module.exports = __webpack_public_path__ + "static/media/spicy-guac-teen-hero-desktop.61a2a572.jpg";